import * as jQuery from 'jquery';
import * as _ from 'underscore';

import { Injectable } from '@angular/core';

import { Widget } from '../interfaces/widget.interface';

/**
 *
 */
@Injectable()
export class ConfigurationLoaderService {
	/**
	 *
	 */
	constructor() {}

	/**
	 *
	 * @param {Widget[]} widgets
	 * @param {string} htmlLayout
	 * @param isCarousel
	 * @param isNavigationCarousel
	 * @returns {string}
	 */
	generateHTMLForWidgets(
		htmlWidgets: Widget[],
		htmlLayout: string,
		isCarousel: any,
		isNavigationCarousel: any,
		isTab: boolean,
		enableLeftNavWidgets: boolean
	): string {
		const htmlEle = jQuery(htmlLayout);
		const widgets: Widget[] = this.sortArrayByType(htmlWidgets, 'displayOrder');
		let widgetHTML = '';
		let widgetNavs;
		let contentHeight;
		let navigationHtml = '';
		let navigationWidgetsHtml = '<div class="tab-content">';
		if (isCarousel && !isNavigationCarousel) {
			widgetNavs = widgets.map((widgetObj) => widgetObj.widget).join(',');
			navigationHtml = `<app-sub-nav widgets="${encodeURI(
				widgetNavs
			)}" (navigateToWidgetSlide)="slideToWidget($event)"><app-sub-nav>`;
			contentHeight = 'calc(100vh - 250px)';
		} else if (isTab) {
			widgetHTML = `<app-nav-tab widgets="${encodeURI(
				JSON.stringify(_.uniq(widgets.map((widgetObj) => widgetObj.widget)))
			)}"></app-nav-tab><div class="tab-content">`;
		} else if (enableLeftNavWidgets) {
			widgetHTML = `<app-nav-tab widgets="${encodeURI(
				JSON.stringify(_.uniq(widgets.map((widgetObj) => widgetObj.widget)))
			)}"></app-nav-tab>`;
		} else {
			contentHeight = 'calc(100vh - 150px)';
		}

		for (const widget of widgets) {
			const tempWidget = `
				<app-${widget.widgetType} sectiontitle="${widget.widgetTitle}" tooltipinfo="${widget.tooltipInfo}" path="${
				widget.path
			}" uniqueoverwriteid="${widget.uniqueOverwriteID}" productType="${
				widget.productType
			}" datatableconfig="${encodeURI(widget.dataTableConfig)}" columnsconfig="${encodeURI(
				widget.columnsConfig
			)}" queryorderBy="${encodeURI(widget.queryOrderBy)}" downloadcsvorderBy="${encodeURI(
				widget.downloadCSVOrderBy
			)}" uikitresponseconfig="${encodeURI(widget.uiKitResponseConfig)}"
				downloadcsvcolumns = "${encodeURI(widget.downloadCSVColumns)}"
					timeserieskey="${widget.query.timeseriesKey}" tertiarykey="${
				widget.query.tertiaryKey
			}" barchartconfiguration="${encodeURI(widget.barChartConfiguration)}"
					noDataMessage="${widget.noDataMessage}" key="${widget.query.key}" secondarykey="${
				widget.query.secondaryKey
			}" iscustomendpoint="${widget.query.isCustomEndPoint}" " issecondarykeyendpoint="${
				widget.query.isSecondaryKeyEndPoint
			}" withoutgam="${widget.query.withoutGam}"
			hasprerollplacementsaccess="${widget.hasPreRollPlacementAccess}"
			downloadcsvcolumns = "${encodeURI(widget.downloadCSVColumns)}"
					colcount="${widget.colCount}" heatmapenabled="${widget.heatmapEnabled}" showgeofencepoints="${
				widget.showGeofencePoints
			}" showgeofenceonoverview="${widget.showGeofenceOnOverview}" showgeocenters="${widget.showGeoCenters}"
					showAllDatesData="${widget.showAllDatesData}"
					showthirdpartyrtg="${widget.showThirdPartyRTG}" liftdistributionenabled="${
				widget.liftDistributionEnabled
			}" liftareacolor="${widget.liftAreaColor}" groupby="${widget.query.groupBy}"
					fields="${encodeURI(widget.query.fields)}" dateformat="${widget.dateFormat}" sectionclass="${
				widget.widgetClass
			}" markericon="${widget.markerIcon}" markericonhover="${widget.markerIconHover}" placeholderimage="${
				widget.placeholderImage
			}" geofencegeovideocallattibutekey="${widget.geofenceGeovideoCallAttibuteKey}"
					colorsconfig="${encodeURI(widget.colorConfig)}" downloadconfig="${encodeURI(
				widget.downloadConfig
			)}" chartconfiguration="${encodeURI(widget.chartConfiguration)}" customchartconfiguration="${encodeURI(
				widget.customChartConfiguration
			)}"
				piechartconfiguration="${encodeURI(widget.pieChartConfig)}" reportingconfig="${encodeURI(
				widget.reportingConfig
			)}" daypartmetric="${encodeURI(widget.daypartMetric)}" legend="${encodeURI(widget.legend)}" sortdataby="${
				widget.sortDataBy
			}" defaultsort="${widget.defaultSort}" impressionsviewedcompletionsrate="${
				widget.impressionsViewedCompletionsRate
			}" metricsarray="${encodeURI(widget.metricsArray)}" creativestats="${encodeURI(widget.creativeStats)}" colors="${
				widget.colors
			}" removekeys="${encodeURI(widget.removeKeys)}" externalwidgetsconfiguration="${encodeURI(
				widget.externalWidgetsConfiguration
			)}" tooltipconfigname="${widget.tooltipConfigName}" scatterconfiguration="${encodeURI(
				widget.scatterConfiguration
			)}" multichartconfigurations="${encodeURI(
				widget.multiChartConfigurations
			)}" multidatatableconfigurations="${encodeURI(
				widget.multiDatatableConfigurations
			)} "multidatatableconfigurations="${encodeURI(
				widget.multiDatatableConfigurations
			)}" seriesviewconfiguration="${encodeURI(widget.seriesViewConfiguration)}" permissionedquerykeys="${encodeURI(
				widget.permissionedQueryKeys
			)}" enableproductdetails="${widget.enableProductDetails}"
				mapboxStyles="${widget.mapboxStyles}" customAccessToken="${widget.customAccessToken}" getdatafromwidget="${
				widget.getDataFromWidget
			}" 
				georecencycirclemarkercolor="${widget.geoRecencyCircleMarkerColor}" geofencecirclemarkercolor="${
				widget.geoFenceCircleMarkerColor
			}"
				></app-${widget.widgetType}>
			`;
			const className = this.getClassByWidgetLayout(widget.widgetLayout);
			const widgetOuterContainer = jQuery('<div class="widgets"></div>');
			jQuery(widgetOuterContainer).addClass(className);
			jQuery(widgetOuterContainer).attr('id', widget.uniqueOverwriteID);
			jQuery(widgetOuterContainer).append(tempWidget);

			if (isTab) {
				widgetHTML += `<div class="tab-pane" unqiue-id="${widget.widget
					.replace(' ', '')
					.replace('&', '')
					.toLocaleLowerCase()}" role="tabpanel">${jQuery(widgetOuterContainer)[0].outerHTML}</div>`;
			} else if (enableLeftNavWidgets) {
				navigationWidgetsHtml += `<div class="tab-pane" unqiue-id="${widget.widget
					.replace(' ', '')
					.toLocaleLowerCase()}" role="tabpanel">${jQuery(widgetOuterContainer)[0].outerHTML}</div>`;
			} else if (!isCarousel) {
				widgetHTML += jQuery(widgetOuterContainer)[0].outerHTML;
			}
		}

		if (isCarousel) {
			widgetHTML += '</div></div>';
			widgetHTML = `<app-section-carousel
					widgetdata="${encodeURI(JSON.stringify(widgets))}" #uiCarousel [infinite]="false" [fade]="false" [speed]="200"
					height="${contentHeight}" width="100%" [dots]="false" [auto-play]="false">`;
			widgetHTML += '</app-section-carousel>';
			widgetHTML = `<div class="sub-nav-container">${navigationHtml}</div>${widgetHTML}`;
		} else if (isTab) {
			widgetHTML += '</div>';
		} else if (enableLeftNavWidgets) {
			navigationWidgetsHtml += '</div>';
		}

		if (enableLeftNavWidgets) {
			const eleFound = jQuery(htmlEle).find('.left-nav-widgets');
			jQuery(eleFound).html(widgetHTML);
			const eleFoundLeftnav = jQuery(htmlEle).find('.widget-grid');
			jQuery(eleFoundLeftnav).html(navigationWidgetsHtml);
		} else {
			const eleFound = jQuery(htmlEle).find('.widget-grid');
			jQuery(eleFound).html(widgetHTML);
		}

		return jQuery(htmlEle)[0].outerHTML;
	}

	/**
	 *
	 * @param {Widget[]} widgets
	 * @param {string} htmlLayout
	 * @returns {string}
	 */
	generateHTMLForOverviewWidgets(widgets: Widget[], htmlLayout: string): string {
		const htmlEle = jQuery(htmlLayout);
		let widgetHTML = '';
		for (const widget of widgets) {
			if (widget) {
				widgetHTML += `
					<div class="o-stack__cell o-stoct_content o-stoct_content overview-widgets ${
						widget.widgetClass
					}" style="padding: 0px 10px;">
						<app-${widget.widgetType} sectiontitle="${widget.widgetTitle}" colors="${widget.colors}" tooltipinfo="${
					widget.tooltipInfo
				}" uniqueoverwriteid="${widget.uniqueOverwriteID}" geofencegeovideocallattibutekey="${
					widget.geofenceGeovideoCallAttibuteKey
				}" 
				georecencycirclemarkercolor="${widget.geoRecencyCircleMarkerColor}" geofencecirclemarkercolor="${
					widget.geoFenceCircleMarkerColor
				}"
				iscustomendpoint="${widget.query.isCustomEndPoint}"
							key="${widget.query.key}" groupby="${widget.query.groupBy}" sectionclass="${
					widget.widgetClass
				}" columnsconfig="${encodeURI(widget.columnsConfig)}" legend="${encodeURI(
					widget.legend
				)}" downloadcsvcolumns = "${encodeURI(widget.downloadCSVColumns)}">
						</app-${widget.widgetType}>
					</div>
				`;
			}
		}
		const eleFound = jQuery(htmlEle).find('.overview-widget-grid');
		jQuery(eleFound).html(widgetHTML);
		return jQuery(htmlEle)[0].outerHTML;
	}

	/**
	 *
	 * @param {Widget[]} widgets
	 * @param {string} htmlLayout
	 * @returns {string}
	 */
	generateHTMLForNavigationWidgets(widgets: Widget[], htmlLayout: string, isCarousel: any): string {
		const htmlEle = jQuery(htmlLayout);
		let widgetHTML = '';
		if (isCarousel) {
			widgetHTML = `<app-navigation-carousel widgetdata="${encodeURI(
				JSON.stringify(widgets)
			)}" uniqueoverwriteid = "navigation-quick-stats"></app-navigation-carousel>`;
		} else {
			for (const widget of widgets) {
				widgetHTML += `
					<li class="c-menu__item navigation-widgets">
						<app-${widget.widgetType} sectiontitle="${widget.widgetTitle}" sectionpath="${widget.widgetPath}"  legend="${encodeURI(
					widget.legend
				)}" columnsconfig="${encodeURI(widget.columnsConfig)}" uniqueoverwriteid="${
					widget.uniqueOverwriteID
				}" geofencegeovideocallattibutekey="${widget.geofenceGeovideoCallAttibuteKey}" getdatafromwidget="${
					widget.getDataFromWidget
				}"
				issecondarykeyendpoint="${widget.query.isSecondaryKeyEndPoint}"
							key="${widget.query.key}" secondarykey="${widget.query.secondaryKey}" downloadconfig="${encodeURI(
					widget.downloadConfig
				)}" downloadcsvcolumns = "${encodeURI(widget.downloadCSVColumns)}" sectionclass="${widget.widgetClass}">
						</app-${widget.widgetType}>
					</li>
				`;
			}
		}

		const eleFound = jQuery(htmlEle).find('.navigation-widget-grid');
		jQuery(eleFound).html(widgetHTML);
		return jQuery(htmlEle)[0].outerHTML;
	}

	getClassByWidgetLayout(layoutSize: string | number): string {
		return `analytics-portlet-${layoutSize}p`;
	}

	sortArrayByType(array: any[], type: string): any[] {
		return _.sortBy(array, type);
	}
}
